import { useLazyQuery } from "@apollo/client";
import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { LoaderDots } from "../../../../middleware/loaders";
import { lang } from "../../../../middleware/lang";
import { GetBranch, GetBranchVariables, GET_BRANCH } from "../queries";
import BranchGeneral from "./branchGeneral";
import BranchSchedule from "./branchSchedule";

type Params = {
  id?: string
};

const BranchView: React.FC = () => {
  const { id } = useParams<Params>();
  const isEdit = !!id;
  const [getBranch, { data: branch, loading: loadingBranch }] = useLazyQuery<GetBranch, GetBranchVariables>(GET_BRANCH);

  useEffect(() => {
    if (isEdit) {
      getBranch({ variables: { id: +id! }});
    }
  }, [getBranch, id, isEdit]);

  if (loadingBranch) {
    return <LoaderDots />;
  }

  return (
    <>
      <p>
        <Link to="/branches">
          <i className="fa fa-chevron-left" aria-hidden="true"></i>{" "}
          {lang("Sucursales", "Branches")}
        </Link>
      </p>
      <h1>
        {isEdit
          ? lang("Editar Sucursal", "Edit Branch")
          : lang("Nueva Sucursal", "New Branch")}
      </h1>

      <div className="row">
        <div className="col-lg-6">
          <BranchGeneral id={id} branch={branch?.getBranch} />
        </div>
        {!!branch && (
          <div className="col-lg-6">
            <BranchSchedule branch={branch.getBranch} />
          </div>
        )}
      </div>
    </>
  );
};

export default BranchView;